export default __webpack_public_path__ + "static/10-most-instagrammable-places-on-earth-japan-17cc205cbbd8a733973223111b93b749.jpg";